import React from "react"

function House({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.1667 16.1479V21.5C12.1667 22.9002 12.1667 23.6002 12.4392 24.135C12.6788 24.6054 13.0613 24.9878 13.5317 25.2275C14.0665 25.5 14.7665 25.5 16.1667 25.5H19.8333C21.2335 25.5 21.9335 25.5 22.4683 25.2275C22.9387 24.9878 23.3212 24.6054 23.5608 24.135C23.8333 23.6002 23.8333 22.9002 23.8333 21.5V12.1667M25.5 18L20.9723 12.97C19.9426 11.826 19.4278 11.254 18.8213 11.0429C18.2888 10.8574 17.7092 10.8574 17.1766 11.043C16.5702 11.2542 16.0555 11.8263 15.0259 12.9704L10.5 18M19.6667 25.5V20.5H16.3333V25.5"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default House
